import React, { useState } from 'react'
import './css/AddProduct.css';
import Navbar from './Navbar';
const AddProduct = () => {
    const [name, setName] = useState('');
    const [cas, setCas] = useState('');

    const submitForm = async (e) => {
        console.log(name);
        e.preventDefault()
        const response = await fetch('https://jivichem.herokuapp.com/api/v1/product/new', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                name,
                cas
            }),
        })

        const data = await response.json()
        if(data.success===true){
            alert("Product Added Sussecfully")
        }else{
            alert("error")
        }

    }
    return (
        <>
            <Navbar />
            <div className='main'>
                <h3>REGISTER  </h3>
                <form>
                    <input
                        id="name"
                        type="text"
                        placeholder="Enter Product Name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                    <input
                        id="cas"
                        type="text"
                        placeholder="Enter cas no"
                        value={cas}
                        onChange={(e) => setCas(e.target.value)}
                    />
                    &nbsp;
                    &nbsp;
                    <button type="submit" id="btnsubmit" onClick={submitForm} >Submit</button>
                </form>
            </div>
        </>
    )
}
export default AddProduct
